import { CLIENT_ROLE } from '@/constants/roles';
import { isRecord } from '@/utils/typeGuards';

/**
 * Clients may use the main platform only when the account is explicitly
 * allowlisted. Admin impersonation is a separate `isAdmin` localStorage path.
 */
export function isClientDirectLoginBlocked(user: unknown): boolean {
  if (!isRecord(user)) {
    return false;
  }
  return user.role === CLIENT_ROLE && !user.direct_login_enabled;
}
